import { UPDATE_REGISTRY } from 'constants/constants';
import { displayActionMessage } from 'helpers/utils';
import { call, put, select } from 'redux-saga/effects';
import firebase from 'services/firebase';
import { setLoading } from '../actions/miscActions';
import { updateRegistrySuccess } from '../actions/registryActions';

function* registrySaga({ type, payload }) {
  switch (type) {
    case UPDATE_REGISTRY: {

      try {
        const state = yield select();

        yield put(setLoading(true));

        yield call(firebase.updateRegistry, state.auth.id, payload.registry);
        yield put(updateRegistrySuccess(payload.registry));

        yield put(setLoading(false));
        yield call(displayActionMessage, 'Registry Updated Successfully!', 'success');
      } catch (e) {
        console.log(e);
        yield put(setLoading(false));
        yield call(displayActionMessage, `:( Failed to update registry. ${e.message ? e.message : ''}`, 'error');
      }
      break;
    }

    default: {
      throw new Error('Unexpected action type.');
    }
  }
}

export default registrySaga;
